import { render } from "./indexBlog.vue?vue&type=template&id=3b585932"
import script from "./indexBlog.vue?vue&type=script&lang=js"
export * from "./indexBlog.vue?vue&type=script&lang=js"

import "./indexBlog.vue?vue&type=style&index=0&id=3b585932&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__